import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shorten-violation' })
export class ShortenHosViolationPipe implements PipeTransform {
  public transform(value) {
    return typeof value === 'string' ? value.replace(' Hours', 'h').replace(' Minutes', 'm')
      .replace(' Hour', 'h').replace(' Minute', 'm') : ''
    ;
  }
}
